export interface TiersMeta {
  permissions: {
    create: boolean;
    edit: boolean;
  };
}

export interface AdminTier {
  id: number;
  name: string;
  max_creators: number | null;
  max_viewers: number | null;
  starting_credit_pool: string | null;
  is_active: boolean;
  organization_count: number | null;
}

export interface TierFormValue {
  name: string;
  max_creators: string;
  max_viewers: string;
  starting_credit_pool: string;
  is_active: boolean;
}

export const TIERS_SUBTAB_CAPS = {
  create: 'admin_panel_tiers_create',
  edit: 'admin_panel_tiers_edit',
} as const;

export const emptyTierForm = (): TierFormValue => ({
  name: '',
  max_creators: '',
  max_viewers: '',
  starting_credit_pool: '',
  is_active: true,
});

export function formFromTier(tier: AdminTier): TierFormValue {
  return {
    name: tier.name || '',
    max_creators: tier.max_creators == null ? '' : String(tier.max_creators),
    max_viewers: tier.max_viewers == null ? '' : String(tier.max_viewers),
    starting_credit_pool: tier.starting_credit_pool == null ? '' : String(tier.starting_credit_pool),
    is_active: tier.is_active,
  };
}

export function formToPayload(value: TierFormValue, mode: 'create' | 'edit') {
  const payload: Record<string, unknown> = {
    name: value.name.trim(),
    max_creators: value.max_creators.trim() === '' ? null : Number(value.max_creators),
    max_viewers: value.max_viewers.trim() === '' ? null : Number(value.max_viewers),
    starting_credit_pool:
      value.starting_credit_pool.trim() === '' ? null : value.starting_credit_pool.trim(),
  };
  if (mode === 'edit') payload.is_active = value.is_active;
  return payload;
}
